import { Progress, Tag } from '@chakra-ui/react';
import MaterialTable from 'material-table';
import React from 'react';
import { useSelector } from 'react-redux';
import { MATERIAL_TABLE_OPTIONS, statusClasses } from './constants';

import { classNames as clx } from '@/utils/classNames';
import { CustomTableToolbar } from 'components/index';
import { components, tableIcons } from 'components/v4/MaterialTable/consts';
import { convertDateFormat } from './helper';

import dummyData from '../dummyData';
import ExportCSVButton from './ExportCSVButton';

export default function LoginsAuditTable() {
    const tableRef = React.useRef(null);
    const { darkMode } = useSelector((state) => state.settings);
    const statusRender = (status) => {
        switch (status) {
            case 'Success':
                return (
                    <Tag className={clx(statusClasses['Active'], 'w-[100px]')}>
                        Success
                    </Tag>
                );

            case 'Fail':
                return (
                    <Tag
                        className={clx(
                            statusClasses['Suspended'],
                            'w-[100px]',
                        )}>
                        Fail
                    </Tag>
                );

            default:
                return null;
        }
    };

    const failedAttemptsColor = (rowData) => {
        const failAttempts = rowData['FailedLoginAttempts'];
        if (failAttempts >= 5) {
            return 'red';
        } else if (failAttempts >= 4) {
            return 'yellow';
        } else {
            return 'blue';
        }
    };

    const defaultColumns = [
        {
            title: 'User ID',
            field: 'UserID',
        },
        {
            title: 'Timestamp',
            field: 'DateTime',
            render: (rowData) => convertDateFormat(rowData.DateTime),
        },
        {
            title: 'Status',
            field: 'Success/Fail',
            render: (rowData) => statusRender(rowData['Success/Fail']),
        },
        {
            title: 'IP Address',
            field: 'IPAddress',
        },
        {
            title: 'Failed Login Attempts',
            field: 'FailedLoginAttempts',
            render: (rowData) =>
                rowData['FailedLoginAttempts'] !== '0' && (
                    <Progress
                        sx={{
                            '&': { marginTop: '17px' },
                        }}
                        value={Number(rowData['FailedLoginAttempts']) * 20}
                        colorScheme={failedAttemptsColor(rowData)}
                    />
                ),
        },
    ];

    const exportCsvOptions = {
        columns: defaultColumns,
        data: dummyData.loginHistory,
        exportCsv: tableRef?.current?.props?.options?.exportCsv,
        titleName: 'Logins Audit',
    };
    return (
        <MaterialTable
            icons={tableIcons}
            tableRef={tableRef}
            columns={defaultColumns}
            data={dummyData.loginHistory}
            options={{
                ...MATERIAL_TABLE_OPTIONS,
                headerStyle: {
                    position: 'sticky',
                    top: 0,
                    background: darkMode ? '#121212' : 'white',
                },
            }}
            components={{
                ...components,
                Toolbar: (props) => {
                    return (
                        <CustomTableToolbar
                            {...props}
                            resetColumnsButton={false}
                        />
                    );
                },
            }}
            title={<ExportCSVButton options={exportCsvOptions} />}
        />
    );
}
